module.exports = __webpack_public_path__ + "img/CCR-4.3a0f1ef7.png";